/**
 * Chaves visuais do frontend (congeladas no BUILD, como todo REACT_APP_*).
 *
 * FÁBRICA EM CONSTRUÇÃO: as abas da Fábrica que ainda não foram adaptadas à
 * operação (Lotes e genealogia, Ficha técnica, Opções de kit) ficam atrás de
 * uma capa "Em construção". É só visual — o backend não trava nada.
 *
 * LIGADA por padrão (a capa aparece): os builds do melidev e do prod não
 * passam a variável, então ficam cobertos sem mexer no CI. No localhost o
 * `.env` desliga com `REACT_APP_FABRICA_EM_CONSTRUCAO=false` para estudar as
 * abas.
 */
const DESLIGADO = ['false', '0', 'off', 'nao', 'não'];

export const FABRICA_EM_CONSTRUCAO = !DESLIGADO.includes(
    String(process.env.REACT_APP_FABRICA_EM_CONSTRUCAO ?? '')
        .trim()
        .toLowerCase(),
);
